import React, { Fragment, Component } from 'react'
import PropTypes from 'prop-types'
import Button from '@material-ui/core/Button'
import Dialog from '../../components/IdentifiedDialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import withMobileDialog from '@material-ui/core/withMobileDialog'
import Input from '@material-ui/core/Input'
import InputLabel from '@material-ui/core/InputLabel'
import FormControl from '@material-ui/core/FormControl'
import { connect } from 'react-redux'
import { imagesTimeActions, messageActions } from '../../actions'
import { withStyles } from '@material-ui/core/styles'
import CircularProgress from '@material-ui/core/CircularProgress'
import Typography from '@material-ui/core/Typography'
import { readOnly } from '../../utils/permissions'

const styles = theme => ({
  box: theme.mixins.gutters({
    paddingTop: 16,
    paddingBottom: 16,
    margin: 'auto',
    width: '80%',
    maxWidth: '400px',
    background: 'blue'
  }),
  errorMessage: {
    position: 'absolute',
    bottom: '-22px',
    left: 0
  },
  wrapperLoader: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minWidth: '280px',
    width: '100%',
    height: '100%',
    minHeight: '200px'
  },
  formGroup: {
    padding: '12px 0'
  },
  root: {
    display: 'flex',
    minHeight: '100%',
    padding: '16px 0',
    boxSizing: 'border-box',
    flexDirection: 'column',
    background: '#fafafa'
  },
  formControl: {
    margin: '14px 0'
  }
})

class EditModal extends Component {
  handleSave = imageTime => {
    const { onClose, addImageTime, editImageTime, changeMessage } = this.props
    if (imageTime._id) {
      editImageTime(imageTime).then(res => {
        changeMessage({ message: 'Alteração realizada com sucesso.' })
        onClose()
      })
    } else {
      addImageTime(imageTime).then(res => {
        changeMessage({ message: 'Cadastro realizado com sucesso.' })
        onClose()
      })
    }
  }

  handleSubmit = (e, imageTime) => {
    e.preventDefault()
    const { setImageTimeFormTouched } = this.props

    if ((this.props.imageTimeFormErrors || {}).valid) {
      this.handleSave(imageTime)
    } else {
      setImageTimeFormTouched()
    }
    return false
  }

  clearErrors = () => {
    this.setState({ formErrors: {} })
  }

  render() {
    const {
      fullScreen,
      onClose,
      open = false,
      classes,
      imageTime,
      handleChangeImageTime,
      loadingImageTime,
      imageTimeFormErrors,
      formTouched,
      token
    } = this.props

    const { handleSubmit, clearErrors } = this
    const isReadOnly = readOnly('imagens_minutos', token)

    return (
      <div>
        <Dialog
          modalId={imageTime._id ? 'imagens-minutos-editar' : 'imagens-minutos-nova'}
          modalParams={{ registro: imageTime._id }}
          fullScreen={fullScreen}
          fullWidth
          open={open}
          onClose={onClose}
          className={classes.dialog}
        >
          {loadingImageTime ? (
            <div className={classes.wrapperLoader}>
              <CircularProgress />
            </div>
          ) : (
            <Fragment>
              <DialogTitle id={(imageTime._id ? 'imagens-minutos-editar' : 'imagens-minutos-nova') + '-title'}>
                {isReadOnly ? (
                  'Imagens_Minutos'
                ) : (
                  <Fragment>
                    {imageTime._id ? 'Editar imagem minutos' : 'Cadastrar imagem minutos'}
                  </Fragment>
                )}
              </DialogTitle>

              <DialogContent>
                <form
                  id={'imageTime-form'}
                  noValidate
                  onSubmit={e => {
                    handleSubmit(e, imageTime)
                  }}
                >
                  <FormControl
                    error={!((imageTimeFormErrors.fields || {})['nome'] || {}).valid && formTouched}
                    className={classes.formControl}
                    fullWidth
                  >
                    <InputLabel htmlFor="field-nome">Nome</InputLabel>
                    <Input
                      disabled={isReadOnly}
                      fullWidth
                      placeholder="Leitura simples"
                      required={'required'}
                      type="text"
                      onChange={e => {
                        clearErrors()
                        handleChangeImageTime({ ...imageTime, nome: e.target.value })
                      }}
                      value={imageTime.nome}
                      autoFocus
                      id="field-nome"
                    />
                    {!((imageTimeFormErrors.fields || {})['nome'] || {}).valid && formTouched ? (
                      <Typography className={classes.errorMessage} noWrap color={'error'}>
                        {((imageTimeFormErrors.fields || {})['nome'] || {}).errorMessage}
                      </Typography>
                    ) : null}
                  </FormControl>
                  <FormControl
                    error={
                      !((imageTimeFormErrors.fields || {})['tempo'] || {}).valid && formTouched
                    }
                    className={classes.formControl}
                    fullWidth
                  >
                    <InputLabel htmlFor="field-tempo">Tempo</InputLabel>
                    <Input
                      disabled={isReadOnly}
                      fullWidth
                      placeholder="Tempo de leitura ( 1 a 999 minutos )"
                      required={'required'}
                      type="text"
                      onChange={e => {
                        clearErrors()
                        handleChangeImageTime({ ...imageTime, tempo: e.target.value })
                      }}
                      value={imageTime.tempo}
                      id="field-tempo"
                    />
                    {!((imageTimeFormErrors.fields || {})['tempo'] || {}).valid && formTouched ? (
                      <Typography className={classes.errorMessage} noWrap color={'error'}>
                        {((imageTimeFormErrors.fields || {})['tempo'] || {}).errorMessage}
                      </Typography>
                    ) : null}
                  </FormControl>
                </form>
              </DialogContent>
              <DialogActions>
                <Button onClick={onClose} color="default">
                  {isReadOnly ? 'Voltar' : 'Cancelar'}
                </Button>
                {!isReadOnly && (
                  <Button type={'submit'} form={'imageTime-form'} color="primary" variant="raised">
                    Salvar
                  </Button>
                )}
              </DialogActions>
            </Fragment>
          )}
        </Dialog>
      </div>
    )
  }
}

EditModal.propTypes = {
  fullScreen: PropTypes.bool.isRequired
}

const mapStateToProps = state => {
  return {
    imageTime: state.imagesTime.imageTime,
    loadingImageTime: state.imagesTime.loadingImageTime,
    imageTimeFormErrors: state.imagesTime.imageTimeFormErrors,
    formTouched: state.imagesTime.imageTimeFormTouched,
    token: state.auth.token
  }
}

const mapDispatchToProps = dispatch => {
  return {
    openModal: () => {
      dispatch(imagesTimeActions.openModal())
    },
    closeModal: () => {
      dispatch(imagesTimeActions.closeModal())
    },
    handleChangeImageTime: imageTime => {
      dispatch(imagesTimeActions.handleChangeImageTime(imageTime))
    },
    addImageTime: imageTime => {
      return dispatch(imagesTimeActions.addImageTime(imageTime))
    },
    editImageTime: imageTime => {
      return dispatch(imagesTimeActions.editImageTime(imageTime))
    },
    setImageTimeFormTouched: imageTime => {
      dispatch(imagesTimeActions.setImageTimeFormTouched())
    },
    changeMessage: ({ message }) => {
      dispatch(messageActions.changeMessage({ message }))
    }
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withMobileDialog()(withStyles(styles)(EditModal)))



// WEBPACK FOOTER //
// ./src/containers/ImagesTime/EditModal.js